module.exports = __webpack_public_path__ + "static/media/employee-management.6b40dd45.gif";